import { render, staticRenderFns } from "./scriptChoose.vue?vue&type=template&id=ad360c64&"
import script from "./scriptChoose.vue?vue&type=script&lang=js&"
export * from "./scriptChoose.vue?vue&type=script&lang=js&"
import style0 from "./scriptChoose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports